import { trpc } from '@/lib/trpc';
import { type DbNotification } from '@/server/db/schema'; // Changed to DbNotification
import { useState } from 'react';

export function useNotifications() {
  const utils = trpc.useUtils();

  const { data: unreadCount, isLoading: isLoadingCount } =
    trpc.notifications.getUnreadCount.useQuery(undefined, {
      staleTime: 30000,
    });

  const {
    data: notificationsData,
    fetchNextPage,
    hasNextPage,
    isLoading: isLoadingList,
    isFetchingNextPage,
  } = trpc.notifications.getNotifications.useInfiniteQuery(
    { limit: 10, filter: 'all' },
    {
      getNextPageParam: (lastPage) => lastPage.nextCursor,
      staleTime: 60000,
    },
  );

  const notifications = notificationsData?.pages.flatMap((page) => page.items) ?? [];

  const markAsReadMutation = trpc.notifications.markAsRead.useMutation({
    onSuccess: (data, variables) => {
      utils.notifications.getUnreadCount.invalidate();
      utils.notifications.getNotifications.invalidate();
    },
    onError: (error) => {
      // TODO: Implement proper error handling (e.g., toast notification)
      console.error("Failed to mark notification as read:", error);
    },
  });

  const markAsRead = (id: string) => {
    if (markAsReadMutation.isPending) return;
    markAsReadMutation.mutate({ id });
  };

  const markAllAsRead = () => {
    if (markAsReadMutation.isPending) return;
    if (unreadCount && unreadCount > 0) {
        markAsReadMutation.mutate({ markAll: true });
    }
  };

  return {
    unreadCount: unreadCount ?? 0,
    notifications,
    isLoadingCount,
    isLoadingList,
    isFetchingNextPage,
    isMarkingRead: markAsReadMutation.isPending,
    hasNextPage: hasNextPage ?? false,
    fetchNextPage,
    markAsRead,
    markAllAsRead,
  };
}

export type UseNotificationsReturn = ReturnType<typeof useNotifications>;